import * as actionTypes from './appSettingsActionTypes';

export const setFetchActiveTransportOrdersTimeout = (timeout) => ({type: actionTypes.SET_FETCH_ACTIVE_TRANSPORTORDERS_TIMEOUT, timeout:timeout});
export const setFetchCompletedTransportOrdersTimeout = (timeout) => ({type: actionTypes.SET_FETCH_COMPLETED_TRANSPORTORDERS_TIMEOUT, timeout:timeout});
export const setFetchHiveStateTimeout = (timeout) => ({type: actionTypes.SET_FETCH_HIVE_STATE_TIMEOUT, timeout:timeout});
